export const getInitialValues = () => ({
  locationType: null,
  locationSubtype: null,
  county: { id: '', name: '' },
  city: { id: '', name: '' },
  locationUsage: null,
  locationUnit: null
})
